var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4067 16.5029C13.7204 16.5029 16.4067 13.8166 16.4067 10.5029C16.4067 7.18922 13.7204 4.50293 10.4067 4.50293C7.09303 4.50293 4.40674 7.18922 4.40674 10.5029C4.40674 13.8166 7.09303 16.5029 10.4067 16.5029ZM10.4067 18.0029C14.5489 18.0029 17.9067 14.6451 17.9067 10.5029C17.9067 6.36079 14.5489 3.00293 10.4067 3.00293C6.2646 3.00293 2.90674 6.36079 2.90674 10.5029C2.90674 14.6451 6.2646 18.0029 10.4067 18.0029Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65674 15.0028V13.9715H11.1567V15.0028H9.65674ZM9.65674 12.7528V6.00275H11.1567V12.7528H9.65674Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.c0576ead9d0808992cbac1d28e9381e2.svg";